import React from "react";
import { useIntl } from "react-intl";
import {
  IonAccordion,
  IonItem,
  IonLabel,
  IonList,
  IonAccordionGroup,
} from "@ionic/react";
import { useQuery } from "react-query";
import { listScheduling } from "../../../api/server";
import moment from "moment";
import { useSelector } from "react-redux";
import SchedulingItem from "./SchedulingItem";
const DayOfVisitScheduling = (props) => {
  const { date, patientId } = props;
  const intl = useIntl();
  const { scopePrefix } = useSelector((state) => state.auth);

  const { isFetching, data } = useQuery(
    [date, patientId],
    async () => {
      const result = await listScheduling({
        scopePrefix,
        current: 1,
        pageSize: 100,
        filter: {},
        query: {
          from: moment(date).startOf("day").format(),
          to: moment(date).endOf("day").format(),
        },
        patientId,
      });
      return result.data.items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: patientId !== null && date !== null,
    }
  );

  return (
    <IonAccordionGroup>
      <IonAccordion>
        <IonItem slot="header">
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.schedulingInVisitDate",
            })}
          </IonLabel>
        </IonItem>
        <IonList slot="content">
          {data &&
            data.map((item) => <SchedulingItem key={item.id} item={item} />)}
        </IonList>
      </IonAccordion>
    </IonAccordionGroup>
  );
};

export default DayOfVisitScheduling;
